// extracted by mini-css-extract-plugin
module.exports = {"signUp":"signUpmodal_signUp__3AS4N","button":"signUpmodal_button__2oS7B","label":"signUpmodal_label__3jSDb"};